import { Component } from '@angular/core';
import { SharedSendMoneyComponent } from '../components/send-money/shared-send-money.component';
import { SharedSendMoneyModule } from '../components/send-money/shared-send-money.module';
import { TransferMoneyComponent } from './components/transfer-money/transfer-money.component';

@Component({
    standalone: true,
    selector: 'app-send-money',
    templateUrl: './send-money.component.html',
    styleUrls: ['./send-money.component.scss'],
    imports: [SharedSendMoneyModule],
})
export class SendMoneyComponent extends SharedSendMoneyComponent {
    public override ngOnInit(): void {
        super.ngOnInit();
        this.columns=   [
            { transaction_timestamp: 'Date Transferred' },
            { transaction_type: 'Type' },
            { sender: 'Sender' },
            { receiver_name: 'Receiver Name' },
            { amount_sent: 'Amount Sent' },
            { transfer_status: 'Transfer Status' },
        ];
        this.redirectToComponent = TransferMoneyComponent;
    }
}
